import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = () => {
  const { isAuthenticated, isReporterAuthenticated, loading } = useSelector(
    (state) => state.auth,
  );
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>; // Show a loading spinner while checking authentication
  }

  // Handle CRM routes
  if (location.pathname.startsWith("/crm")) {
    return isAuthenticated ? <Outlet /> : <Navigate to="/crm-login" replace />;
  }

  // Handle Reporter routes
  if (location.pathname.startsWith("/reporter-landing")) {
    return isReporterAuthenticated ? (
      <Outlet />
    ) : (
      <Navigate to="/reporter-login" replace />
    );
  }

  // Default redirect if no matching route
  return <Navigate to="/crm-login" replace />;
};

export default ProtectedRoute;
